if (window.matchMedia('(max-width: 990px)').matches) {
  const viewport = document.querySelector('.configurator.toggle-menu .embla__viewport')
  
  if (viewport) {
    const embla = EmblaCarousel(viewport, { 
      align: 'start', 
      containScroll: 'trimSnaps' 
    })

    const prevBtn = document.querySelector('.configurator.toggle-menu .embla__prev')
    const nextBtn = document.querySelector('.configurator.toggle-menu .embla__next')

    const updateArrows = () => {
      prevBtn.classList.toggle('disabled', !embla.canScrollPrev())
      nextBtn.classList.toggle('disabled', !embla.canScrollNext())
    }

    embla.on('select', updateArrows)
    embla.on('init', updateArrows)
    updateArrows()

    const selectedIndex = [...viewport.querySelectorAll('.embla__slide')].findIndex(select => select.classList.contains('selected'))

    if (selectedIndex > -1) {
      embla.scrollTo(selectedIndex, true)
    }

    document.querySelector('.configurator.toggle-menu .embla__prev').onclick = () => embla.scrollPrev()
    document.querySelector('.configurator.toggle-menu .embla__next').onclick = () => embla.scrollNext()
  }
}